<div class="checkbox" [class.checkbox--disabled]="disabled()">
  <input
    type="checkbox"
    [id]="id()"
    [checked]="checked()"
    [disabled]="disabled()"
    class="checkbox__native"
    (change)="onChange($event)"
  />
  <label [for]="id()" class="checkbox__visual-label">
    <span
      class="checkbox__box"
      [class.checkbox__box--checked]="checked()"
      aria-hidden="true"
    >
      @if (checked()) {
        <app-icon [icon]="checkIcon" [size]="12" color="white" [strokeWidth]="3" />
      }
    </span>
    @if (label()) {
      <span class="checkbox__text">{{ label() }}</span>
    }
  </label>
</div>
